/**
 * An array of routes that are publicly accessible. These routes do not require authentication
 * @type {string[]}
 */
export const publicRoutes: string[] = [
  "/auth/email-verification",
  "/public/confirm",
  "/public",
  "/privacy-policy",
  "/terms-of-service",
  "/web/bookings",
  "/web/invoices",
  "/web/jobs",
  "/web/quotes",
  "/web/self-service",
  "/web/notifications",
  "/web/contact",
  "/",
];

/**
 * An array of routes that are used for authentication.
 * These routes route you to you dashboard
 * @type {string[]}
 */
export const authRoutes: string[] = [
  "/auth/login",
  "/auth/register",
  "/auth/reset",
  "/auth/new-password",
  "/auth/invitation",
  "/auth/auth-error",
  "/auth/trial-registration",
  "/auth/trial-registration/contact",
  "/auth/trial-registration/calendar",
  "/auth/trial-registration/subscription",
  "/auth/trial-registration/banking",
  "/auth/trial-registration/done",
];

/**
 * The prefix for API routes
 * @type {string}
 */
export const apiAuthPrefix: string = "/api/auth";
export const apiPrefix: string = "/api";

/**
 * The default redirect location after authentication
 * @type {string}
 */
export const DEFAULT_LOGIN_REDIRECT: string = "/secure/appointment";
export const DEFAULT_LOGIN_REDIRECT_PUBLIC: string = "/public?step=2";
